export default __webpack_public_path__ + "static/media/DSHARE.586d6b44.png";